import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import CardsPage from "./pages/CardsPage";
import PrivateClassesPage from "./pages/PrivateClassesPage";
import { PrivateClassViewMorePage } from "./components/ViewMorePage/PrivateClassViewMorePage";

export function PrivateClassesRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
          ]}
          component={CardsPage}
        />
        <AuthRoute
          exact
          path={`${path}/manage`}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Teacher,
          ]}
          component={PrivateClassesPage}
        />
        <AuthRoute
          exact
          path={`${path}/:id`}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
          ]}
          component={PrivateClassViewMorePage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
